export const STAGES = ['new','contacted','qualified','discovery','proposal','negotiation','won','lost'];
export const TEXT_FIELDS = ['companyName','facilityName','facilityType','industry','contactName','firstName','lastName','title','email','phone','address','city','state','zip','leadSource','ownerUid','notes','nextFollowUpAt'];
export function salesAccess(user, access, uid) {
  const enabled = x => x?.active === true && x.disabled !== true && x.archived !== true;
  return !!uid && enabled(user) && enabled(access) && user.status === 'active' &&
    (access.status === undefined || access.status === 'active') &&
    (user.platformRole || user.role) === 'owner_admin' && (!user.role || user.role === 'owner_admin') &&
    access.role === 'owner_admin' && (!access.platformRole || access.platformRole === 'owner_admin') &&
    (!access.uid || access.uid === uid) && /^[a-z0-9][a-z0-9_-]*$/.test(access.tenantId || '') &&
    access.tenantId !== 'all' && user.tenantId === access.tenantId;
}
export const stageOf = lead => ({proposal_sent:'proposal'}[lead.stage || lead.status] || lead.stage || lead.status || 'new');
export function dateKey(value, timeZone) {
  if (!value || !timeZone) return null;
  try {
    const fmt = new Intl.DateTimeFormat('en-CA',{timeZone,year:'numeric',month:'2-digit',day:'2-digit'});
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) { fmt.format(new Date()); return value; }
    const date=value?.toDate ? value.toDate() : new Date(value);
    const parts=Object.fromEntries(fmt.formatToParts(date).map(p=>[p.type,p.value]));
    return `${parts.year}-${parts.month}-${parts.day}`;
  } catch { return null; }
}
export function followUp(lead, timezone, now=new Date()) {
  if (['won','lost'].includes(stageOf(lead))) return 'closed';
  if (!(lead.nextFollowUpAt || lead.nextFollowUp)) return 'none';
  const day=dateKey(lead.nextFollowUpAt || lead.nextFollowUp,timezone), today=dateKey(now,timezone);
  return !day || !today ? 'unknown' : day < today ? 'overdue' : day === today ? 'today' : 'upcoming';
}
export function filterLeads(rows, filters, uid, timezone, now=new Date()) {
 return rows.filter(row=>{
  const follow=followUp(row,timezone,now);
  const age=Number(now)-Number(row.createdAt?.toDate?.() || new Date(row.createdAt));
  const recent=age>=0 && age<=7*86400000;
  if(filters.view==='My Leads' && row.ownerUid!==uid) return false;
  if(filters.view==='Unassigned' && row.ownerUid) return false;
  if(filters.view==='Needs Follow-up' && !['today','overdue'].includes(follow)) return false;
  if(filters.view==='Recently Added' && !recent) return false;
  if(filters.stage && stageOf(row)!==filters.stage) return false;
  if(filters.follow && follow!==filters.follow) return false;
  if(filters.role && !(row.rolesNeeded || []).includes(filters.role)) return false;
  for(const key of ['ownerUid','leadSource','facilityType','state']) if(filters[key] && row[key]!==filters[key]) return false;
  const hay=['companyName','facilityName','contactName','firstName','lastName','email','phone'].map(k=>row[k]||'').join(' ').toLowerCase();
  return hay.includes((filters.search||'').toLowerCase());
 });
}
export function duplicates(rows, draft) {
 const norm=(v,k)=>String(v||'').toLowerCase().replace(k==='phone'?/\D/g:/\s+/g,k==='phone'?'':' ').trim();
 return rows.filter(row=>['companyName','facilityName','email','phone','address'].some(k=>norm(draft[k],k) && norm(draft[k],k)===norm(row[k],k)));
}
export function leadPayload(draft) {
 const data=Object.fromEntries(TEXT_FIELDS.map(k=>[k,String(draft[k]||'').trim()]));
 if(!data.companyName && !data.facilityName) throw new Error('Company or facility name is required.');
 if(Object.values(data).some(v=>v.length>4000)) throw new Error('A field exceeds 4,000 characters.');
 const stage=stageOf(draft); if(!STAGES.includes(stage)) throw new Error('Select a valid stage.');
 if(data.nextFollowUpAt && !/^\d{4}-\d{2}-\d{2}$/.test(data.nextFollowUpAt)) throw new Error('Choose a follow-up date.');
 for (const key of ['rolesNeeded','staffingNeeds']) if ((draft[key]||[]).filter(Boolean).some(v=>!['CNA','LVN','LPN','RN','Med Aide','Caregiver','Other'].includes(v))) throw new Error('Staffing roles must be CNA, LVN, LPN, RN, Med Aide, Caregiver or Other.');
 return {...data,email:data.email.toLowerCase(),stage,status:stage,rolesNeeded:(draft.rolesNeeded||[]).filter(v=>typeof v==='string' && v.trim()),staffingNeeds:(draft.staffingNeeds||[]).filter(v=>typeof v==='string' && v.trim())};
}
